import { render, staticRenderFns } from "./DnsOverview.vue?vue&type=template&id=16dd67e8&"
import script from "./DnsOverview.vue?vue&type=script&lang=js&"
export * from "./DnsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports